import React from "react";
import { IIconProps } from "../../Interface/IconProps";
import { ComponentIcon } from "../../lib/svgIcon/components";
import staticIcons from "./staticIcons";

export interface SvgIconProps extends IIconProps {}

const SvgIcon = (props: SvgIconProps) => {
  const { icon, ...rest } = props;

  // check static icons
  if (staticIcons[icon]) {
    return React.createElement(staticIcons[icon], {
      key: icon,
      ...props,
      className: (props.className || "") + " svg-icon-static",
      color: "transparent",
    });
  }

  return <>{ComponentIcon({ name: icon, key: icon, props: { ...rest } })}</>;
};

export default SvgIcon;
